import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(VueAxios, axios);

const http = Vue.axios.create({
  baseURL: process.env.VUE_APP_APP_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

http.interceptors.request.use((config) => {
  const idToken = localStorage.getItem("id_token");
  if (idToken) {
    config.headers.Authorization = `Bearer ${idToken}`;
  }
  return config;
});

http.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const token = localStorage.getItem("id_token");
    if (!!token && error.response && error.response.status === 401) {
      // Clear the cached token
      localStorage.removeItem("id_token");

      // Redirect the admin to the login page
      window.location.href = "/#/login";
    }
    return Promise.reject(error);
  }
);

export default http;
